module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_6_1.2aef3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_6_1.png
// module id = IzVz
// module chunks = 0